import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { safeLocalStorage } from "../utils/safeStorage";
import { clearStoredAuthSession, storeUserName } from "../services/auth/persistLoginSession";

export const useAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = safeLocalStorage.getItem("accessToken");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
    setLoading(false);
  }, [navigate]);

  const login = (token: string, email: string, redirectToHome: boolean) => {
    safeLocalStorage.setItem("accessToken", token);
    safeLocalStorage.setItem("userEmail", email);
    setIsLoggedIn(true);
    if (redirectToHome) {
      navigate("/home");
    }
  };

  const loginWithUser = (
    token: string,
    user: { id: string; email: string; first_name: string | null; last_name: string | null },
    redirectToHome: boolean,
  ) => {
    safeLocalStorage.setItem("accessToken", token);
    safeLocalStorage.setItem("userEmail", user.email);
    safeLocalStorage.setItem("userId", user.id);
    storeUserName(user.first_name, user.last_name);
    setIsLoggedIn(true);
    if (redirectToHome) {
      navigate("/home");
    }
  };

  const logout = () => {
    clearStoredAuthSession();
    setIsLoggedIn(false);
    navigate("/login");
  };

  return { isLoggedIn, loading, login, loginWithUser, logout };
};
